var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGeojsonIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 62.42 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bookmark"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.36,48.37H7.23V12.58h13.5l8.56,7.99h24.93v6.08h5.16v-8.87c0-1.22-1.03-2.26-2.29-2.26H31.39l-8.41-7.84s-.23-.15-.38-.15H4.36c-1.26,0-2.29,.99-2.29,2.26V51.16c0,1.22,1.03,2.26,2.29,2.26h13v-5.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.69,34.87h2.87v6.52c-1.7,1.38-4.09,2.08-6.4,2.08-5.07,0-8.8-3.53-8.8-8.41s3.74-8.41,8.85-8.41c2.73,0,5.02,.91,6.56,2.66l-1.91,1.87c-1.28-1.28-2.76-1.87-4.51-1.87-3.48,0-5.93,2.36-5.93,5.74s2.45,5.74,5.91,5.74c1.17,0,2.31-.23,3.36-.84v-5.09h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.18,37.93h-9.78c.35,1.82,1.87,2.99,4.04,2.99,1.4,0,2.5-.44,3.39-1.35l1.56,1.8c-1.12,1.33-2.87,2.03-5.02,2.03-4.18,0-6.89-2.69-6.89-6.4s2.73-6.38,6.45-6.38,6.31,2.55,6.31,6.45c0,.23-.02,.58-.05,.86h0Zm-9.81-1.94h7.08c-.23-1.8-1.61-3.04-3.53-3.04s-3.27,1.21-3.55,3.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.02,36.99c0-3.74,2.8-6.38,6.63-6.38s6.66,2.64,6.66,6.38-2.78,6.4-6.66,6.4-6.63-2.66-6.63-6.4h0Zm10.34,0c0-2.38-1.59-3.9-3.71-3.9s-3.69,1.52-3.69,3.9,1.59,3.9,3.69,3.9,3.71-1.52,3.71-3.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.53,55.04l1.03-1.24c.54,.72,1.17,1.12,1.94,1.12,1,0,1.52-.61,1.52-1.8v-5.07h-3.48v-1.52h5.3v6.49c0,2.31-1.14,3.43-3.32,3.43-1.24,0-2.36-.51-3.04-1.42h.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.89,55.28l.63-1.42c.79,.63,2.03,1.07,3.25,1.07,1.52,0,2.17-.54,2.17-1.28,0-2.12-5.81-.72-5.81-4.37,0-1.59,1.26-2.92,3.95-2.92,1.17,0,2.41,.3,3.27,.86l-.58,1.42c-.89-.51-1.84-.77-2.71-.77-1.52,0-2.12,.58-2.12,1.33,0,2.08,5.81,.72,5.81,4.32,0,1.56-1.28,2.92-3.97,2.92-1.52,0-3.06-.47-3.85-1.17h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.13,51.43c0-2.9,2.24-5.04,5.28-5.04s5.28,2.12,5.28,5.04-2.24,5.04-5.28,5.04-5.28-2.15-5.28-5.04Zm8.73,0c0-2.01-1.47-3.46-3.46-3.46s-3.46,1.45-3.46,3.46,1.47,3.43,3.46,3.43,3.46-1.45,3.46-3.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60.35,46.52v9.81h-1.49l-5.39-6.63v6.63h-1.8v-9.81h1.49l5.39,6.63v-6.63h1.8Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeojsonIcon);
export default __webpack_public_path__ + "static/media/geojson-icon.7f13d4815f3d481d2741f58fb934f2d9.svg";
export { ForwardRef as ReactComponent };